module.exports = __webpack_public_path__ + "img/rect_silencer_2.7112cca2.png";